module.exports = __webpack_public_path__ + "static/media/burning_weapon.af1ab6e1.png";